var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadedIFrame)?_c('section',{staticClass:"w-100"},[_c('iframe',{attrs:{"src":"https://sogeti-app-qualityeye-d.azurewebsites.net","height":"800px","width":"100%","frameborder":"0","onload":"document.getElementById('spinner').style.display='none';"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }